import React, { useRef, useState } from "react";
import {
 Paper,
 Table,
 TableBody,
 TableCell,
 TableContainer,
 TableHead,
 TableRow,
} from "@mui/material";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import bankingService from "../../../components/Services/banking.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import moment from "moment";
import NodataFound from "../../../commons/Toast/noDataFound";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import documentUploadService from "../../../components/Services/documentUpload.service";
import { Preview } from "@mui/icons-material";
import UploadedDocument from "../../Documents/UploadedDocument";

const BankingLedger = ({ data, getBankingLedger }) => {
 const [isAddNewMonth, setAddNewMonth] = useState(false);
 const [editMonth, setEditMonth] = useState();
 const [selectedFiles, setSelectedFiles] = useState(null);
 const [selectedFileData, setSelectedFileData] = useState(null);
 const [isPdfOpen, setIsPdfOpen] = useState(false);

 const formikRef = useRef();
 const fileInputRef = useRef(null);

 const handleAddNewLedgerMonth = (item) => {
  setAddNewMonth(!isAddNewMonth);
  setEditMonth(item);
  if (item) {
   getDocDataById(item?.ledgerDocumentId);
  }
 };
 let isEditCase = Boolean(editMonth);
 const initialValues = {
  ledgerMonth: isEditCase ? editMonth?.month && new Date(editMonth?.month) : "",
  amount: isEditCase ? editMonth?.amount : "",
  againstAmount: isEditCase ? editMonth?.againstAmount : "",
  LEDGER: "",
 };
 const validationSchema = Yup.object().shape({
  againstAmount: Yup.string().required("Required Field"),
  amount: Yup.string().required("Required Field"),
  ledgerMonth: Yup.date().required("Please Select Month"),
  LEDGER: Yup.mixed().required("Please Upload Document"),
 });
 const getDocDataById = (id, viewFile) => {
  documentUploadService
   .getDocumentById(id)
   .then((response) => {
    if (response?.data?.code === 200) {
     formikRef.current &&
      formikRef.current.setFieldValue("LEDGER", response?.data?.data);
     if (viewFile) {
      let fileTypeSplit = response?.data?.data?.fileName.split(".");
      setSelectedFiles(fileTypeSplit[fileTypeSplit?.length - 1]);
      setSelectedFileData(response?.data?.data?.fileInBytes);
      setIsPdfOpen(true);
     }
    }
   })
   .catch((err) => console.log("Api call Error:", err));
 };
 const handleViewFile = (ledgerDocId) => {
  getDocDataById(ledgerDocId, true);
 };

 const handleProofOfPayment = (e, setFieldValue, key, type) => {
  const fun = async (e) => {
   const fileList = e?.target?.files;
   if (fileList.length > 0) {
    const file = fileList[0];
    let extension = file.name.split(".").pop();
    let fileSize = file.size / 1024 / 1024;
    let extList = ["pdf"];
    if (fileSize < 10) {
     if (extList.includes(extension)) {
      let formData = new FormData();
      formData.append("file", file);
      const config = {
       headers: {
        "Content-Type": "multipart/form-data",
       },
      };
      let data = (
       await documentUploadService.documentUpload(type, formData, config)
      )?.data;
      if (data?.data) {
       setFieldValue(key, data?.data || "");
       toast.success("Uploaded Successfully", toastProperties);
      } else {
       fileInputRef.current.value = null;
       toast.error("Failed to upload File", toastProperties);
       setFieldValue(key, "");
      }
     } else {
      fileInputRef.current.value = null;
      setFieldValue(key, "");
      toast.error(
       "Only Pdf formats can be uploaded",
       toastProperties
      );
     }
    } else {
     fileInputRef.current.value = null;
     toast.error("File Size Cannot Exceed 10mb", toastProperties);
     setFieldValue(key, "");
    }
   } else {
    setFieldValue(key, "");
    fileInputRef.current.value = null;
   }
  };
  fun(e);
 };
 const handleClosePDFModal = () => {
  setIsPdfOpen(false);
 };
 const numberInputOnWheelPreventChange = (e) => {
  e.target.blur();
  // Prevent the page/container scrolling
  e.stopPropagation();
  // Refocus immediately, on the next tick (after the current function is done)
  setTimeout(() => {
   e.target.focus();
  }, 0);
 };
 return (
  <>
   {isPdfOpen && (
    <UploadedDocument
     fileData={selectedFileData}
     handleCloseModal={handleClosePDFModal}
     fileType={selectedFiles}
     isOpen={isPdfOpen}
    />
   )}
   <div>
    {data?.ledgers?.length > 0 ? (
     <>
      <h5>Ledger</h5>
      <TableContainer component={Paper} elevation={2}>
       <Table
        // sx={{ minWidth: 200, width: "auto", maxWidth: "100%" }}
        align="center"
        aria-label="customized table"
       >
        <TableHead className="table-header">
         <TableRow>
          <TableCell
           align="center"
           sx={{ borderRight: 0.1, borderColor: "whitesmoke" }}
          >
           Month
          </TableCell>
          {data?.ledgers?.map((item) => (
           <TableCell
            align="center"
            key={item.id}
            sx={{ borderRight: 0.1, borderColor: "whitesmoke" }}
           >
            {item.month}
            <span
             className="pointer-event"
             onClick={() => {
              handleAddNewLedgerMonth(item);
             }}
             style={{ marginLeft: "2px" }}
            >
             <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Edit</Tooltip>}
             >
              <EditOutlinedIcon />
             </OverlayTrigger>
            </span>
           </TableCell>
          ))}
         </TableRow>
        </TableHead>
        <TableBody>
         <TableRow>
          <TableCell
           align="center"
           sx={{ borderRight: 0.1, borderColor: "whitesmoke" }}
          >
           Injection(MW)*
          </TableCell>
          {data?.ledgers?.map((item) => (
           <TableCell
            align="center"
            key={`${item.id}-amount`}
            sx={{ borderRight: 0.1, borderColor: "whitesmoke" }}
           >
            {item.amount}
           </TableCell>
          ))}
         </TableRow>
         <TableRow>
          <TableCell
           align="center"
           sx={{ borderRight: 0.1, borderColor: "whitesmoke" }}
          >
           Drawal(MW)*
          </TableCell>
          {data?.ledgers?.map((item) => (
           <TableCell
            align="center"
            key={`${item.id}-againstAmount`}
            sx={{ borderRight: 0.1, borderColor: "whitesmoke" }}
           >
            {item.againstAmount}
           </TableCell>
          ))}
         </TableRow>
        </TableBody>
       </Table>
      </TableContainer>
     </>
    ) : (
     <NodataFound />
    )}
    <div className="d-flex  justify-content-center mt-3">
     <button
      className="btn btn-bookmark"
      onClick={() => handleAddNewLedgerMonth(null)}
     >
      Add New
     </button>
    </div>
    {isAddNewMonth && (
     <Modal
      show={isAddNewMonth}
      onHide={() => handleAddNewLedgerMonth()}
      className="modal"
      size="md"
     >
      <Modal.Header closeButton>
       <Modal.Title>{isEditCase ? "Edit Ledger" : "Add New Ledger"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
       <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
         let reqBody = {
          id: editMonth?.id,
          connectionId: data?.id,
          month: moment(values?.ledgerMonth).format("MMM-YYYY"),
          amount: values?.amount,
          againstAmount: values?.againstAmount,
          ledgerDocumentId: values.LEDGER?.id,
         };
         bankingService.createLedger(reqBody).then((response) => {
          if (response?.data?.code === 200) {
           getBankingLedger();
           toast.success(response?.data?.message, toastProperties);
           setAddNewMonth(false);
          }
         });
        }}
       >
        {({ values, setFieldValue, setFieldTouched, setValues }) => {
         console.log("form_values===>", { values });
         return (
          <Form>
           <div className="login-box-vh-center">
            <div className="login-box">
             <div className="p-4 gap-3">
              <div>
               <label htmlFor="ledgerMonth">Ledger Month*</label>
               <DatePicker
                className="form-control custom-input w-100"
                name="ledgerMonth"
                popperPlacement="bottom-start"
                placeholderText="Select Date"
                popperModifiers={{
                 flip: {
                  behavior: ["bottom"],
                 },
                 preventOverflow: {
                  enabled: false,
                 },
                }}
                selected={values.ledgerMonth}
                onChange={(e) => setFieldValue("ledgerMonth", e)}
                dateFormat="MMM-yyyy"
                onBlur={() => setFieldTouched("ledgerMonth", true)}
                autoComplete="off"
                showMonthYearPicker
                //   maxDate={new Date()}
               />
               <ErrorMessage
                name="ledgerMonth"
                component="div"
                className="text-danger"
               />
              </div>
              <div className="mt-2">
               <label htmlFor="amount">Injection(MW)*</label>
               <Field
                type="number"
                onWheel={numberInputOnWheelPreventChange}
                className="custom-input no-spinner"
                placeholder=""
                name="amount"
                onKeyDown={(e) => {
                 if (
                  e.key === "-" ||
                  e.key === "e" ||
                  e.key === "ArrowUp" ||
                  e.key === "ArrowDown"
                 ) {
                  e.preventDefault();
                 }
                }}
               />
               <ErrorMessage
                name="amount"
                component="div"
                className="text-danger"
               />
              </div>
              <div className="mt-2">
                     <label htmlFor="againstAmount">Drawal(MW)*</label>
               <Field
                type="number"
                onWheel={numberInputOnWheelPreventChange}
                className="custom-input no-spinner"
                placeholder=""
                name="againstAmount"
                onKeyDown={(e) => {
                 if (
                  e.key === "+" ||
                  e.key === "e" ||
                  e.key === "ArrowUp" ||
                  e.key === "ArrowDown"
                 ) {
                  e.preventDefault();
                 }
                }}
               />
               <ErrorMessage
                name="againstAmount"
                component="div"
                className="text-danger"
               />
              </div>
              <div className="mt-2">
               <div className="d-flex gap-2">
                <label className="form-check-label" htmlFor="LEDGER">
                 Upload Ledger Document*
                </label>
                {values?.LEDGER && (
                 <div
                  className="pointer-event mb-1"
                  onClick={() => handleViewFile(values?.LEDGER?.id)}
                 >
                  <OverlayTrigger
                   placement="right"
                   overlay={<Tooltip>Preview</Tooltip>}
                  >
                   <Preview color="warning" />
                  </OverlayTrigger>
                 </div>
                )}
               </div>
               <div className="file-input-wrapper">
                <input
                 type="file"
                 id="file-input3"
                 className="file-input"
                 onChange={(e) =>
                  handleProofOfPayment(e, setFieldValue, "LEDGER", "LEDGER")
                 }
                 ref={fileInputRef}
                />
                <span>{values.LEDGER?.fileName}</span>
                <label htmlFor="file-input3" className="file-input-label">
                 {isEditCase ? "Update" : "Browse"}
                </label>
               </div>
               <ErrorMessage
                name="LEDGER"
                className="text-danger"
                component="div"
               />
              </div>
              <div className="mt-4 d-flex  justify-content-center">
               <button type="submit" className="btn btn-approve">
                Submit
               </button>
              </div>
             </div>
            </div>
           </div>
          </Form>
         );
        }}
       </Formik>
      </Modal.Body>
     </Modal>
    )}
   </div>
  </>
 );
};
export default BankingLedger;
